import styled from "styled-components";

export const StyledLoading = styled.div`
    width: 100%;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--grey-0);

    p{
        font-size: 48px;
        color: var(--information);

    }



`